import React, { useEffect, useState } from 'react';
import themeConfig from '@configs/themeConfig';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink, OffcanvasHeader, Offcanvas,
  UncontrolledDropdown, OffcanvasBody
} from 'reactstrap';
import { ChevronDown, Layers, Users, Zap, Home } from 'react-feather';
import { HiOutlineUserGroup } from 'react-icons/hi';

import { getUserData } from '../../../../utility/Utils';
import Avatar from '@components/avatar';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { isMobile } from 'react-device-detect';
import UserDropdown from '../UserDropdown';
import { FaFacebookMessenger, FaLayerGroup } from 'react-icons/fa';
import { BiCalendarCheck, BiSolidZap } from 'react-icons/bi';
import { CgShoppingCart } from 'react-icons/cg';
import {Tooltip } from 'reactstrap';
import {LuAlignCenter, LuAlignLeft} from "react-icons/lu";
import {responsiveItems} from "../../../../views/community/tab/Profile";
import {setProfileTab} from "../../../../views/community/tab/Profile/store/reducer";
import {handleLogout} from "../../../../redux/authentication";
import {AiOutlinePoweroff} from "react-icons/ai";

const NavItemWithTooltip = ({ id, to, activeMenu, icon, tooltipText, label, isMobile }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

  return (
    <NavItem className="px-2">
      <NavLink
        id={id}
        tag={Link}
        to={to}
        active={activeMenu === label}
        className={`${activeMenu === label ? 'text-primary' : 'text-secondary'} ${isMobile ? 'px-0' : ''}`}
      >
        {icon}
      </NavLink>
      <Tooltip
        placement="top"
        isOpen={tooltipOpen}
        target={id}
        toggle={toggleTooltip}
      >
        {tooltipText}
      </Tooltip>
    </NavItem>
  );
};



export default function ClientNavbar({ scrolling }) {
  const userData = getUserData();
  const userLocation = JSON.parse(localStorage.getItem('location'));
  const [selectedLogo, setSelectedLogo] = useState(themeConfig.app.appLogoImage);
  const [selectedLocation, setSelectedLocation] = useState(themeConfig.app.appName);

  const handleChangeLocation = (loc) => {
    localStorage.setItem('location', JSON.stringify(loc));
    window.location.href = '/community/home';
  };

  useEffect(() => {
    if (userLocation && userLocation !== null) {
      if (userLocation?.logo) {
        setSelectedLogo(userLocation?.logo);
        setSelectedLocation(userLocation?.organizationName);
      }
    }
  }, [userLocation]);

  return (
    <div>
      <div
        style={{ zIndex: '997' }}
        className={'position-fixed w-100 bg-white py-50 px-1'
        }
        id="client-community-navbar"
      >
        <div className={`d-flex justify-content-between `}>
          {isMobile ? null : (
            <div className="my-auto">
              <div className="d-flex align-items-center">
                <Avatar img={selectedLogo} />
                <h5 className="brand-text my-auto ms-1">{selectedLocation}</h5>
                <UncontrolledDropdown className="my-auto">
                  <DropdownToggle tag={'span'} className="cursor-pointer">
                    <ChevronDown />
                  </DropdownToggle>
                  <DropdownMenu>
                    {userData?.roles?.map((x, idx) => {
                      return (
                        <DropdownItem
                          className="w-100"
                          key={idx}
                          onClick={() => handleChangeLocation(x)}
                        >
                          {x?.assignerCompanyName}
                        </DropdownItem>
                      );
                    })}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </div>
          )}
          {isMobile ? null : (
            <div>
              <div className="d-flex justify-content-end">
                <UserDropdown userData={userData}/>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}